var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"g-terms-list"},_vm._l((_vm.list),function(item){return _c('li',{key:item.title},[_c('a',{attrs:{"href":item.url}},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('i',{staticClass:"g-icon-new-arrow-right"})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }